import React from 'react';
import { TableRow } from '@material-ui/core';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { DEFAULT_TABLE_ROW_HEIGHT, HoverLink, LoaderRow, TableCell, Typography } from '../../../../ui-kit';
import { useUser } from '../../../../utils/hooks/auth';
import { useDateTimeService } from '../../../../utils/hooks/dateTimeService';
import { getFullName, localizeEnum } from '../../../../utils';
import { DeductionReason } from '../../../../generated/graphql';
import { usePriceService } from '../../../../utils/hooks/priceService';
import { DeductionLists } from './types';
import { deductionListsHeadCells } from './constants';

interface DeliveryListsTableContentProps {
    deductionLists: DeductionLists;
    isLoading: boolean;
    rowsPerPage: number;
}

const DeductionListsTableContent = ({ deductionLists, isLoading, rowsPerPage }: DeliveryListsTableContentProps) => {
    const match = useRouteMatch();
    const { t } = useTranslation();
    const { priceService } = usePriceService();
    const { user: { cultureCode, defaultCurrency } } = useUser();
    const { dateTimeService } = useDateTimeService();
    const history = useHistory();
    const referrer = history.location.pathname;

    return isLoading
        ? <LoaderRow columnCount={deductionListsHeadCells.length} itemsPerPage={rowsPerPage} itemHeight={DEFAULT_TABLE_ROW_HEIGHT} />
        : (
            <>
                {deductionLists.map(row => (
                    <TableRow tabIndex={-1} key={row.id}>
                        {deductionListsHeadCells.map((cell, index) => {
                            let cellValue: React.ReactNode;
                            if (cell.id === 'deductionDateUtc') {
                                const deliveryListUrl = `${match.url}/${row.id}`;

                                cellValue = (
                                    <HoverLink wide to={{ pathname: deliveryListUrl, state: { referrer } }}>
                                        {dateTimeService.localizeDate(row[cell.id], cultureCode)}
                                    </HoverLink>
                                );
                             } else if (cell.id === 'deductionReason') {
                                cellValue = localizeEnum(t)(row[cell.id], { DeductionReason });
                            } else if (cell.id === 'deductionListItemsTotalCost') {
                                cellValue = priceService.toLocaleString(row[cell.id], defaultCurrency.currencyCode);
                            } else if (cell.id === 'createdBy') {
                                const createdBy = row[cell.id];
                                cellValue = getFullName(createdBy);
                            } else {
                                cellValue = row[cell.id];
                            }
                            return (
                                <TableCell align={cell.align} isSticky={index === 0} key={`${cell.id} - ${row.id}`}>
                                    <Typography variant='body2'>{cellValue}</Typography>
                                </TableCell>
                            );
                        })}
                    </TableRow>
                ))}
            </>
        );
};

export default DeductionListsTableContent;
